import React from "react";

import { useTranslation } from "react-i18next";
import Row from "components/Row";
import Icon from "components/Icon";
import Column from "components/Column";
import Section from "components/Section";
import TextSubscript from "components/TextSubscript";

import { Text, TextDescription, TextTitle } from "components/Texts";

import colors from "styles/colors";

const SpendingAndConversion = ({ spendingConversionInfo }) => {
  return (
    <div className="spending-result">
      {spendingConversionInfo.map((item, index) => (
        <SpendingResultItem
          key={index}
          title={item.title}
          value={item.value}
          unit={item.unit}
          change={item.change}
          icon={item.icon}
        />
      ))}
    </div>
  );
};

const SpendingResultItem = ({ title, value, unit, change, icon }) => {
  const [t] = useTranslation();
  const isNodata = value === "-";
  return (
    <Section className="item">
      <Row alignItems="center">
        {icon && (
          <Column wrap>
            <Icon name={icon} size="22px" color={isNodata ? colors.descriptionText : colors.primary} />
          </Column>
        )}
        <Column>
          <TextTitle>{title}</TextTitle>
        </Column>
        <Column wrap>
          {isNodata ? (
            <TextDescription>{t("__no_data")}</TextDescription>
          ) : (
            <TextSubscript valueText={value} subscriptText={unit} />
          )}
        </Column>
      </Row>
      {!isNodata && (
        <Column wrap>
          {change === "N/A" ? (
            <Text size="12px" align="right" color="#A8A8A8">
              N/A
            </Text>
          ) : (
            <Text
              size="12px"
              align="right"
              color={
                change.indexOf("+") > -1
                  ? colors.positive
                  : change.indexOf("%") > -1 && change !== "0%"
                    ? colors.negative
                    : ""
              }
            >
              {change}
            </Text>
          )}
        </Column>
      )}
    </Section>
  );
};

export default SpendingAndConversion;
